Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "PinnedPost3223544117",
  {"root":"PinnedPost3223544117--root","header":"PinnedPost3223544117--header","icon":"PinnedPost3223544117--icon","headerText":"PinnedPost3223544117--headerText"},
  "",
  10,
  "PinnedPost3223544117"
);

